import { MLM } from '@sunrise/tracking'
import { AmsItem } from '../../services/amsSearch/amsSearch.interface'

export enum MlmActionIds {
    CLICK = 2,
    VIEWPORT = 74,
    VIEW = 1,
}

const ITEM_CHANNEL = 'auto'
const TYPE_PAID_PREMIUM = 'premium'
const AFFILIATE_ID = 55

export const buildMlmData = (
    items: AmsItem[],
    componentId: string,
    page: number,
    actionId: MlmActionIds,
    pageUrl: string,
): MLM.TrackingData => {
    return {
        actionId,
        page: page,
        itemChannel: ITEM_CHANNEL,
        componentId: componentId,
        pageUrl: pageUrl,
        affiliateId: getAffiliateIdFromRefOr(AFFILIATE_ID),
        items: buildMlmItems(items),
    }
}

const buildMlmItems = (items: AmsItem[]): MLM.Item[] =>
    items.map((item) => {
        return {
            id: item.externalId,
            type: item.advertiserKey,
            typePaid: TYPE_PAID_PREMIUM,
            typePosition: item.position,
        }
    })

/**
 * @description considers the URL ref parameter
 */
const getAffiliateIdFromRefOr = (fallback: number) => {
    const refParamString = new URL(window.location.href).searchParams.get('ref')

    if (!refParamString) {
        return fallback
    }

    const refParamNumber = Number(refParamString)

    if (!isFinite(refParamNumber) || refParamNumber <= 0) {
        return fallback
    }
    return refParamNumber
}
